import React from 'react'
import PropTypes from 'prop-types'

import { v4 as uuidv4 } from 'uuid'
import clsx from 'clsx'

import { Paper, Radio, makeStyles } from '@material-ui/core'

import RadioGroupContext from 'contexts/RadioGroupContext'

import styles from './styles'

const useStyles = makeStyles(styles)

const RadioCard = ({ name, value, data, className, children }) => {
  const classes = useStyles(styles)
  const context = React.useContext(RadioGroupContext)
  const radioId = React.useMemo(() => uuidv4(), [])

  const handleClick = () => {
    context.selectValue(value, data)
  }

  const isSelected = () => context.selectedValue === value

  return (
    <div className={clsx(classes.root, className)} onClick={handleClick}>
      <Radio
        name={name}
        value={value}
        checked={isSelected()}
        id={radioId}
        className={classes.radio}
      />
      <Paper
        variant="outlined"
        component="label"
        elevation={0}
        htmlFor={radioId}
        className={classes.paper}
      >
        {children}
      </Paper>
    </div>
  )
}

RadioCard.propTypes = {
  name: PropTypes.string,
  value: PropTypes.any,
  data: PropTypes.any,
}

export default RadioCard
